import * as React from 'react'
import type { SVGProps } from 'react'

export const SvgTrashCan = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 448 512'
		width='1em'
		height='1em'
		{...props}
	>
		<path
			fill='currentColor'
			d='M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm80 80v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z'
		/>
	</svg>
)
